<template>
  <div>about</div>
</template>

<script setup lang="ts"></script>
